import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { removeLeadingZeros } from '../../../../utils/Helper';

export const WaterAreaView = (props) => {
  const { formData } = props;
  const landuse = formData.info.landuse_and_beneficiaries;

  return (
    <AccordionBodyItemView
      accordionSubId="8.7"
      titleUA="Акваторії"
      titleEN="Water Area"
      children={(
        <div className="flex-group flex-wrap">
          {removeLeadingZeros(landuse.land_water ?? 0)}
        </div>
      )}
    />
  );
};
